import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Key — passkey / Face ID sign-in and step-up. */
export function KeyIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <circle cx="8" cy="12" r="3.6" />
      <path d="M11.6 12H21M17.5 12v3.2M21 12v2.4" />
    </PortalIcon>
  );
}
